import React from 'react';
import {FieldViewSize} from "../../../../const";
import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty";

export default function FieldDropdown_InlineValueEmpty(props:FieldEditableValueNotEmptyProps) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    const classes = Classes("ui5-field-dropdown-inline-editable min-w-125", props.className, {
        'ui5-txt-no-accent-default'     : size === FieldViewSize.DEFAULT,
        'ui5-txt-no-accent-small'       : size === FieldViewSize.SMALL,

        // the smaller box - see the note in value-not-empty
        'size-small'                    : size === FieldViewSize.SMALL,
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {/* lifted like the filled value's label, so the text does not move once a value
                    is picked - see FieldDropdown_ValueNotEmpty */}
                <div className="m-b-2">{props.field.placeholder}</div>
            </div>
            {props.children}
        </React.Fragment>
    )

}

